interface CostItem {
  category: string;
  description: string;
  minCost: number;
  maxCost: number;
}

interface CostEstimatorProps {
  petType: string;
  costs: CostItem[];
}

export default function CostEstimator({ petType, costs }: CostEstimatorProps) {
  const totalMin = costs.reduce((sum, item) => sum + item.minCost, 0);
  const totalMax = costs.reduce((sum, item) => sum + item.maxCost, 0);

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="font-headline font-semibold text-2xl text-foreground mb-6">
        Estimated First-Year Costs for {petType}
      </h3>
      <div className="space-y-4 mb-6">
        {costs.map((item, index) => (
          <div key={index} className="flex items-start justify-between py-3 border-b border-border last:border-0">
            <div className="flex-1 min-w-0 pr-4">
              <h4 className="font-body font-medium text-foreground mb-1">{item.category}</h4>
              <p className="text-sm text-muted-foreground">{item.description}</p>
            </div>
            <div className="flex-shrink-0 text-right">
              <p className="font-headline font-semibold text-lg text-primary">
                ${item.minCost} - ${item.maxCost}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="pt-4 border-t-2 border-primary/20">
        <div className="flex items-center justify-between">
          <h4 className="font-headline font-semibold text-xl text-foreground">Total Estimated Cost</h4>
          <p className="font-headline font-bold text-2xl text-primary">
            ${totalMin.toLocaleString()} - ${totalMax.toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
}